/**
 * Product-main section: gallery, bundle/variant picker, one-time vs.
 * subscribe toggle, quantity stepper, accordions, and the sticky add-to-cart
 * bar. All pricing variants are pre-rendered server-side into the
 * `[data-ch-pdp-data]` JSON blob (see sections/product-main.liquid) so
 * switching bundles/purchase-type needs no network round trip — only the
 * actual "Add to cart" click talks to the server, via window.CellhackCart.
 */
(function () {
  const section = document.querySelector('.ch-pdp');
  if (!section) return;

  const dataEl = section.querySelector('[data-ch-pdp-data]') || document.querySelector('[data-ch-pdp-data]');
  let data = { sellingPlanId: null, variants: [] };
  try {
    data = JSON.parse(dataEl.textContent);
  } catch (error) {
    console.error('[cellhack-product-main] could not parse product data', error);
  }

  function formatMoney(cents) {
    const format = window.themeMoneyFormat || '£{{amount}}';
    const amount = (cents / 100).toFixed(2);
    const withCommas = amount.replace(/\B(?=(\d{3})+(?!\d)(?=\.))/g, ',');
    return format.replace(/\{\{\s*amount\s*\}\}/, withCommas).replace(/\{\{\s*amount_no_decimals\s*\}\}/, Math.round(cents / 100).toString());
  }

  const bundleButtons = Array.from(section.querySelectorAll('[data-ch-bundle-tile]'));
  const initiallySelected = section.querySelector('[data-ch-bundle-tile].is-selected');

  const state = {
    variantId: initiallySelected
      ? Number(initiallySelected.getAttribute('data-variant-id'))
      : bundleButtons.length && data.variants[1]
        ? data.variants[1].id
        : data.variants[0] && data.variants[0].id,
    purchaseType: 'onetime',
    qty: 1,
  };

  function findVariant(id) {
    return data.variants.find((v) => v.id === id) || data.variants[0];
  }

  function render() {
    const variant = findVariant(state.variantId);
    if (!variant) return;

    bundleButtons.forEach((btn) => {
      const isSelected = Number(btn.getAttribute('data-variant-id')) === variant.id;
      btn.classList.toggle('is-selected', isSelected);
      btn.setAttribute('aria-pressed', String(isSelected));
    });

    const oncePriceEl = section.querySelector('[data-ch-once-price]');
    if (oncePriceEl) oncePriceEl.textContent = variant.priceFormatted;

    const onceCompareEl = section.querySelector('[data-ch-once-compare]');
    if (onceCompareEl) {
      onceCompareEl.textContent = variant.compareFormatted || '';
      onceCompareEl.hidden = !variant.compareFormatted;
    }

    const subPriceEl = section.querySelector('[data-ch-sub-price]');
    if (subPriceEl) subPriceEl.textContent = variant.subPriceFormatted;

    const subCompareEl = section.querySelector('[data-ch-sub-compare]');
    if (subCompareEl) subCompareEl.textContent = variant.priceFormatted;

    const unitPrice = state.purchaseType === 'subscribe' ? variant.subPrice : variant.price;
    const lineTotal = formatMoney(unitPrice * state.qty);

    // Savings against the crossed-out compare-at price ---------------------
    const compareUnit = variant.compare || 0;
    const saveUnit = compareUnit > unitPrice ? compareUnit - unitPrice : 0;
    const savingEl = section.querySelector('[data-ch-saving]');
    if (savingEl) {
      savingEl.hidden = !saveUnit;
      if (saveUnit) {
        const pct = Math.round((saveUnit * 100) / compareUnit);
        savingEl.textContent = 'You save ' + formatMoney(saveUnit * state.qty) + ' (' + pct + '%)';
      }
    }
    const atcWasEl = section.querySelector('[data-ch-atc-was]');
    if (atcWasEl) {
      atcWasEl.hidden = !saveUnit;
      atcWasEl.textContent = saveUnit ? formatMoney(compareUnit * state.qty) : '';
    }
    const oncePriceWrap = section.querySelector('.ch-pdp__purchase-price');
    if (oncePriceWrap) oncePriceWrap.classList.toggle('is-sale', variant.compare > variant.price);

    section.querySelectorAll('[data-ch-line-total], [data-ch-line-total-mirror]').forEach((el) => {
      el.textContent = lineTotal;
    });

    const qtyValueEl = section.querySelector('[data-ch-qty-value]');
    if (qtyValueEl) qtyValueEl.textContent = state.qty;

    const stickyVariantEl = section.querySelector('[data-ch-sticky-variant]');
    if (stickyVariantEl) {
      stickyVariantEl.textContent = variant.title + (state.purchaseType === 'subscribe' ? ' · Subscribe & save' : '');
    }

    const mainAtc = section.querySelector('[data-ch-atc-main]');
    const stickyAtc = section.querySelector('[data-ch-atc-sticky]');
    [mainAtc, stickyAtc].forEach((btn) => {
      if (!btn) return;
      btn.toggleAttribute('aria-disabled', !variant.available);
      const label = btn.querySelector('span');
      if (label && btn === mainAtc) label.textContent = variant.available ? 'Add to cart' : 'Sold out';
    });
  }

  // Bundle tiles ------------------------------------------------------------
  bundleButtons.forEach((btn) => {
    btn.addEventListener('click', () => {
      state.variantId = Number(btn.getAttribute('data-variant-id'));
      render();
    });
  });

  // One-time / subscribe ------------------------------------------------------
  const purchaseOptions = Array.from(section.querySelectorAll('[data-ch-purchase-option]'));
  purchaseOptions.forEach((btn) => {
    btn.addEventListener('click', () => {
      state.purchaseType = btn.getAttribute('data-ch-purchase-option') === 'subscribe' ? 'subscribe' : 'onetime';
      purchaseOptions.forEach((option) => {
        const selected = option === btn;
        option.classList.toggle('is-selected', selected);
        const dot = option.querySelector('.ch-pdp__radio-dot');
        if (dot) dot.classList.toggle('is-on', selected);
      });
      render();
    });
  });

  // Quantity ------------------------------------------------------------------
  const qtyDec = section.querySelector('[data-ch-qty-dec]');
  const qtyInc = section.querySelector('[data-ch-qty-inc]');
  if (qtyDec) qtyDec.addEventListener('click', () => {
    state.qty = Math.max(1, state.qty - 1);
    render();
  });
  if (qtyInc) qtyInc.addEventListener('click', () => {
    state.qty += 1;
    render();
  });

  // Gallery ---------------------------------------------------------------
  const slides = Array.from(section.querySelectorAll('[data-ch-slide]'));
  const thumbs = Array.from(section.querySelectorAll('[data-ch-thumb]'));
  const counterEl = section.querySelector('[data-ch-counter]');

  function selectSlide(index) {
    slides.forEach((slide, i) => slide.classList.toggle('is-hidden', i !== index));
    thumbs.forEach((thumb, i) => thumb.classList.toggle('is-active', i === index));
    if (counterEl) {
      counterEl.textContent = String(index + 1).padStart(2, '0') + ' / ' + String(slides.length).padStart(2, '0');
    }
  }
  thumbs.forEach((thumb, index) => thumb.addEventListener('click', () => selectSlide(index)));
  if (slides.length) selectSlide(0);

  // Accordions (single-open) --------------------------------------------------
  const accordions = Array.from(section.querySelectorAll('[data-ch-accordion]'));
  accordions.forEach((accordion) => {
    const trigger = accordion.querySelector('[data-ch-accordion-trigger]');
    const panel = accordion.querySelector('[data-ch-accordion-panel]');
    const icon = accordion.querySelector('[data-ch-accordion-icon]');
    if (!trigger || !panel) return;
    trigger.addEventListener('click', () => {
      const isOpen = !panel.hidden;
      accordions.forEach((other) => {
        const otherPanel = other.querySelector('[data-ch-accordion-panel]');
        const otherTrigger = other.querySelector('[data-ch-accordion-trigger]');
        const otherIcon = other.querySelector('[data-ch-accordion-icon]');
        if (otherPanel) otherPanel.hidden = true;
        if (otherTrigger) otherTrigger.setAttribute('aria-expanded', 'false');
        if (otherIcon) otherIcon.textContent = '+';
      });
      if (!isOpen) {
        panel.hidden = false;
        trigger.setAttribute('aria-expanded', 'true');
        if (icon) icon.textContent = '−';
      }
    });
  });

  // Sticky add-to-cart bar ------------------------------------------------
  // Desktop: appears once the main button has scrolled out of view above.
  // Phones: appears after a short scroll whenever the main button is off
  // screen, so a visitor can buy from the first screens of the page.
  const anchor = section.querySelector('[data-ch-atc-anchor]');
  const stickyBar = section.querySelector('[data-ch-sticky-bar]');
  if (anchor && stickyBar && 'IntersectionObserver' in window) {
    const phone = window.matchMedia('(max-width: 767px)');
    let anchorVisible = true;
    let anchorAbove = false;
    const updateSticky = () => {
      const show = !anchorVisible && (phone.matches ? window.scrollY > 240 : anchorAbove);
      stickyBar.classList.toggle('is-visible', show);
    };
    new IntersectionObserver(
      ([entry]) => {
        anchorVisible = entry.isIntersecting;
        anchorAbove = entry.boundingClientRect.top < 0;
        updateSticky();
      },
      { threshold: 0 }
    ).observe(anchor);
    window.addEventListener('scroll', updateSticky, { passive: true });
  }

  // Tap-to-zoom on the main image ---------------------------------------------
  const zoomTarget = section.querySelector('[data-ch-zoom]');
  const lightbox = section.querySelector('[data-ch-lightbox]');
  if (zoomTarget && lightbox) {
    const lightboxImg = lightbox.querySelector('img');
    const closeLightbox = () => {
      lightbox.hidden = true;
      document.body.style.overflow = '';
    };
    const openLightbox = () => {
      const visible = slides.find((slide) => !slide.classList.contains('is-hidden'));
      const img = visible && visible.querySelector('img');
      if (!img) return;
      lightboxImg.src = img.currentSrc || img.src;
      lightboxImg.alt = img.alt;
      lightbox.hidden = false;
      document.body.style.overflow = 'hidden';
    };
    zoomTarget.addEventListener('click', openLightbox);
    zoomTarget.addEventListener('keydown', (event) => {
      if (event.key === 'Enter' || event.key === ' ') {
        event.preventDefault();
        openLightbox();
      }
    });
    lightbox.addEventListener('click', closeLightbox);
    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && !lightbox.hidden) closeLightbox();
    });
  }

  // Add to cart -------------------------------------------------------------
  function addToCart() {
    const variant = findVariant(state.variantId);
    if (!variant || !variant.available) return;
    const item = { id: variant.id, quantity: state.qty };
    if (state.purchaseType === 'subscribe' && data.sellingPlanId) {
      item.selling_plan = data.sellingPlanId;
    }
    window.CellhackCart && window.CellhackCart.add([item]);
  }

  const mainAtc = section.querySelector('[data-ch-atc-main]');
  const stickyAtc = section.querySelector('[data-ch-atc-sticky]');
  if (mainAtc) mainAtc.addEventListener('click', addToCart);
  if (stickyAtc) stickyAtc.addEventListener('click', addToCart);

  render();
})();
